export const locales = {
    "pt-BR": require( "../../locales/pt-BR" ).default,
    "es-MX": require( "../../locales/es-MX" ).default,
};

export const supportedLanguages = [ "es-MX", "pt-BR" ];
